import { reactive, computed } from '@vue/composition-api'
import { checkEmailFormat } from '@/util/validation'

export const ContractAccountEdit = (props, context) => {
  const store = context.root.$store
  const { contract } = store.state
  store.dispatch('contract/getContractData')
  const user = store.getters['users/getCurrentUser']

  const state = reactive({
    isAdminEdit: user.auth !== 0 && contract.account_number >= 2
  })

  const changeUser = reactive({
    name: user.name,
    email: user.email,
    emailConfirm: user.email
  })

  const validation = reactive({
    isSubmit: false,
    name: {
      require: computed(() => changeUser.name !== '')
    },
    email: {
      require: computed(() => changeUser.email !== ''),
      format: computed(() => checkEmailFormat(changeUser.email))
    },
    emailConfirm: {
      require: computed(() => changeUser.email === '' || (changeUser.email !== '' && changeUser.emailConfirm !== '')),
      same: computed(() => changeUser.email === '' || (changeUser.email !== '' && changeUser.email === changeUser.emailConfirm))
    },
    all: computed(() => {
      // 決定ボタン押下前(isSubmit:false)の場合はチェックしない
      return validation.isSubmit &&
        validation.name.require &&
        validation.email.require &&
        validation.email.format &&
        validation.emailConfirm.require &&
        validation.emailConfirm.same
    })
  })

  const close = () => {
    context.emit('closeEdit')
  }
  const submit = () => {
    validation.isSubmit = true
    if (validation.all) {
      // TODO: 保存
      context.emit('submit', changeUser)
    }
  }
  const openAdmin = () => {
    context.emit('openAdminPopup')
  }

  return {
    close,
    submit,
    openAdmin,
    user,
    changeUser,
    validation,
    state
  }
}
